export default {
  LAUNCH: 'LAUNCH',
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  SEND_MARKETING_MAIL: 'SEND_MARKETING_MAIL',
  DATA_SUBMITTED_TRYOUT: 'DATA_SUBMITTED_TRYOUT',
  PRESSED_TRY_FOR_FREE: 'PRESSED_TRY_FOR_FREE',
  PRESSED_GO_TO_TALENTS: 'PRESSED_GO_TO_TALENTS',
  PRESSED_CONTACT_SALES: 'PRESSED_CONTACT_SALES',
  PRESSED_PAYWALL: 'PRESSED_PAYWALL',
  PRESSED_BUTTON_PAYWALL_GENERAL: 'PRESSED_BUTTON_PAYWALL_GENERAL',
  PRESSED_BUTTON_PAYWALL_PUBLIC_INVITATION_LINK:
    'PRESSED_BUTTON_PAYWALL_PUBLIC_INVITATION_LINK',
  PRESSED_BUTTON_PAYWALL_TALENTPOOL: 'PRESSED_BUTTON_PAYWALL_TALENTPOOL',
  DISPLAY_RELEASE_NOTES: 'DISPLAY_RELEASE_NOTES',
  SWITCH_LANGUAGE: 'SWITCH_LANGUAGE',
  PRESSED_TAB: 'PRESSED_TAB',
  INVITE_TALENT: 'INVITE_TALENT',
  INVITE_TALENT_POOL: 'INVITE_TALENT_POOL',
  INVITE_TALENT_CAREER: 'INVITE_TALENT_CAREER',
  INVITE_VIA_LINK: 'INVITE_VIA_LINK',
  INVITE_VIA_EMAIL: 'INVITE_VIA_EMAIL',
  DELETE_TALENT: 'DELETE_TALENT',
  DELETE_TALENTS: 'DELETE_TALENTS',
  RECOVER_TALENTS: 'RECOVER_TALENTS',
  REMOVE_SPACE_CONNECTION_TO_PARTNER_TALENTS:
    'REMOVE_SPACE_CONNECTION_TO_PARTNER_TALENTS',
  REMIND_TALENT: 'REMIND_TALENT',
  REMIND_TALENTS: 'REMIND_TALENTS',
  RESET_EXPIRED_TALENT: 'RESET_EXPIRED_TALENT',
  RESET_EXPIRED_TALENTS: 'RESET_EXPIRED_TALENTS',
  COMMENT_TALENT: 'COMMENT_TALENT',
  OPEN_APPLICANT_STATUS: 'OPEN_APPLICANT_STATUS',
  UPDATE_APPLICANT_STATUS: 'UPDATE_APPLICANT_STATUS',
  ABORT_APPLICANT_STATUS: 'ABORT_APPLICANT_STATUS',
  UPDATE_CAREER_ASSESSMENT_SETTINGS: 'UPDATE_CAREER_ASSESSMENT_SETTINGS',
  UPDATE_CAREER_ASSESSMENT_SETTINGS_PHOTO_URL:
    'UPDATE_CAREER_ASSESSMENT_SETTINGS_PHOTO_URL',
  ARCHIVE_CAREER: 'ARCHIVE_CAREER',
  ABORT_CREATE_CAREER: 'ABORT_CREATE_CAREER',
  FINISH_CREATE_CAREER: 'FINISH_CREATE_CAREER',
  INVITE_EXPERT_TO_CAREER_ANALYSE: 'INVITE_EXPERT_TO_CAREER_ANALYSE',
  DELETE_CAREER_ANALYSE: 'DELETE_CAREER_ANALYSE',
  FINISH_CAREER_ANALYSE_BY_EXPERT: 'FINISH_CAREER_ANALYSE_BY_EXPERT',
  FINISH_CAREER_ANALYSE_BY_PRESETS: 'FINISH_CAREER_ANALYSE_BY_PRESETS',
  FINISH_CAREER_ANALYSE_BY_CAREER: 'FINISH_CAREER_ANALYSE_BY_CAREER',
  REMIND_EXPERT_CAREER_ANALYSE: 'REMIND_EXPERT_CAREER_ANALYSE',
  ACTIVATE_PUBLIC_LINK_INVITATION: 'ACTIVATE_PUBLIC_LINK_INVITATION',
  PRESSED_PUBLIC_LINK_INVITATION: 'PRESSED_PUBLIC_LINK_INVITATION',
  UPDATE_PUBLIC_LINK_INVITATION: 'UPDATE_PUBLIC_LINK_INVITATION',
  ABORT_PUBLIC_LINK_INVITATION: 'ABORT_PUBLIC_LINK_INVITATION',
  ACTIVATE_PUBLIC_LINK_INVITATION_POOL: 'ACTIVATE_PUBLIC_LINK_INVITATION_POOL',
  UPDATE_PUBLIC_LINK_INVITATION_POOL: 'UPDATE_PUBLIC_LINK_INVITATION_POOL',
  ABORT_PUBLIC_LINK_INVITATION_POOL: 'ABORT_PUBLIC_LINK_INVITATION_POOL',
  DUPLICATE_CAREER: 'DUPLICATE_CAREER',
  // veraltet, ersetzt durch SAMPLE_DATA_*. Erst löschen, wenn keine Auswertung
  // mehr darauf zeigt.
  DELETE_DEMO_DATA: 'DELETE_DEMO_DATA',
  CREATE_DEMO_DATA: 'CREATE_DEMO_DATA',
  // Beispieldaten, jeweils mit `source` (Einstieg, z. B. hint_careers, settings)
  SAMPLE_DATA_REMOVE_OPENED: 'SAMPLE_DATA_REMOVE_OPENED',
  SAMPLE_DATA_REMOVE_SUCCEEDED: 'SAMPLE_DATA_REMOVE_SUCCEEDED',
  SAMPLE_DATA_REMOVE_FAILED: 'SAMPLE_DATA_REMOVE_FAILED',
  SAMPLE_DATA_ADD_SUCCEEDED: 'SAMPLE_DATA_ADD_SUCCEEDED',
  SAMPLE_DATA_HINT_DISMISSED: 'SAMPLE_DATA_HINT_DISMISSED',
  UPDATE_RESULT_REPORTS_SETTINGS_V1: 'UPDATE_RESULT_REPORTS_SETTINGS_V1',
  UPDATE_RESULT_REPORTS_SETTINGS_V2: 'UPDATE_RESULT_REPORTS_SETTINGS_V2',
  UPDATE_DASHBOARD_COMPONENTS_SETTINGS: 'UPDATE_DASHBOARD_COMPONENTS_SETTINGS',
  UPGRADE_PLAN: 'UPGRADE_PLAN',
  UPDATE_CAREER_ATTRACT_SETTINGS: 'UPDATE_CAREER_ATTRACT_SETTINGS',
  SHOW_NET_PROMOTER_SCORE: 'SHOW_NET_PROMOTER_SCORE',
  SUBMIT_NET_PROMOTER_SCORE: 'SUBMIT_NET_PROMOTER_SCORE',
  PRESSED_SETTINGS_TAB: 'PRESSED_SETTINGS_TAB',
  PRESSED_PRODUCTTOUR: 'PRESSED_PRODUCTTOUR',
  PRESSED_TALENTS: 'PRESSED_TALENTS',
  PRESSED_HELP_SUPPORT: 'PRESSED_HELP_SUPPORT',
  PRESSED_CAREERS: 'PRESSED_CAREERS',
  PRESSED_TEAMANALYSES: 'PRESSED_TEAMANALYSES',
  ABORT_PRODUCTTOUR: 'ABORT_PRODUCTTOUR',
  COMPLETE_PRODUCTTOUR: 'COMPLETE_PRODUCTTOUR',
  PRESSED_TRYOUT_CHALLENGE: 'PRESSED_TRYOUT_CHALLENGE',
  DELETE_USER: 'DELETE_USER',
  PRESSED_TAB_INVITE_EXPERTS: 'PRESSED_TAB_INVITE_EXPERTS',
  PRESSED_TAB_SELECT_CAREER: 'PRESSED_TAB_SELECT_CAREER',
  PRESSED_TAB_USE_PRESETS: 'PRESSED_TAB_USE_PRESETS',
  // PROFILES
  PREVIEW_REQUIREMENT_PROFILE: 'PREVIEW_REQUIREMENT_PROFILE',
  DOWNLOAD_REQUIREMENT_PROFILE: 'DOWNLOAD_REQUIREMENT_PROFILE',
  VIEW_REQUIREMENT_PROFILE: 'VIEW_REQUIREMENT_PROFILE',
  VIEW_STRENGTH_PROFILE_V2: 'VIEW_STRENGTH_PROFILE_V2',
  VIEW_STRENGTH_PROFILE_V1: 'VIEW_STRENGTH_PROFILE_V1',
  VIEW_MATCHING_PROFILE: 'VIEW_MATCHING_PROFILE',
  DOWNLOAD_ATTACHMENTS_BUNDLE: 'DOWNLOAD_ATTACHMENTS_BUNDLE',
  OPEN_PDF_BUNDLE_DIALOG: 'OPEN_PDF_BUNDLE_DIALOG',
  VIEW_MATCHING_PROFILE_CROSSCOMPARISON:
    'VIEW_MATCHING_PROFILE_CROSSCOMPARISON',
  VIEW_TEAM_PROFILE: 'VIEW_TEAM_PROFILE',
  // ___
  CLICK_REQUEST_CHALLENGES_CROSSMODE: 'CLICK_REQUEST_CHALLENGES_CROSSMODE',
  SHOW_DIAGNOSTIC_VERSION_1_CROSSMODE: 'SHOW_DIAGNOSTIC_VERSION_1_CROSSMODE',
  SHOW_DIAGNOSTIC_VERSION_2_CROSSMODE: 'SHOW_DIAGNOSTIC_VERSION_2_CROSSMODE',
  CLICK_REQUEST_CHALLENGES_TALENT_DETAILS:
    'CLICK_REQUEST_CHALLENGES_TALENT_DETAILS',
  NAVIGATE_TO_RELEASE_NOTES: 'NAVIGATE_TO_RELEASE_NOTES',
  NAVIGATE_TO_TEST_LIBRARY: 'NAVIGATE_TO_TEST_LIBRARY',
  NAVIGATE_TO_SUPPORT: 'NAVIGATE_TO_SUPPORT',
  NAVIGATE_TO_PROFILE: 'NAVIGATE_TO_PROFILE',
  CREATE_TEAMANALYSIS: 'CREATE_TEAMANALYSIS',
  ABORT_CREATE_TEAMANALYSIS: 'ABORT_CREATE_TEAMANALYSIS',
  COMPLETE_CREATE_TEAMANALYSIS: 'COMPLETE_CREATE_TEAMANALYSIS',
  VIEW_TEAMANALYSIS: 'VIEW_TEAMANALYSIS',
  DELETE_TEAMANALYSIS: 'DELETE_TEAMANALYSIS',
  VIEW_TALENT_TEAMANALYSIS: 'VIEW_TALENT_TEAMANALYSIS',
  CLICK_EXPORT_TO_PNG_TEAMANALYSIS: 'CLICK_EXPORT_TO_PNG_TEAMANALYSIS',
  CLICK_OPEN_PDF_TEAMANALYSIS: 'CLICK_OPEN_PDF_TEAMANALYSIS',
  CLICK_MORE_INFORMATION_TEAMANALYSIS: 'CLICK_MORE_INFORMATION_TEAMANALYSIS',
  CLICK_CONFIGURATION_TEAMANALYSIS: 'CLICK_CONFIGURATION_TEAMANALYSIS',
  CLICK_INVITE_TALENTPOOL_TEAMANALYSIS: 'CLICK_INVITE_TALENTPOOL_TEAMANALYSIS',
  DOWNLOAD_INTERPRETATIONGUIDE_TEAMANALYSIS:
    'DOWNLOAD_INTERPRETATIONGUIDE_TEAMANALYSIS',
  HIDE_SPACE_SET_STATE_HINT: 'HIDE_SPACE_SET_STATE_HINT',
  PRESS_SPACE_SET_STATE_TALENTTABLE: 'PRESS_SPACE_SET_STATE_TALENTTABLE',
  CLICK_NAV_FEATURES_LANDINGPAGE: 'CLICK_NAV_FEATURES_LANDINGPAGE',
  CLICK_NAV_TESTIMONIALS_LANDINGPAGE: 'CLICK_NAV_TESTIMONIALS_LANDINGPAGE',
  CLICK_NAV_PRICING_LANDINGPAGE: 'CLICK_NAV_PRICING_LANDINGPAGE',
  CLICK_NAV_LOGIN_LANDINGPAGE: 'CLICK_NAV_LOGIN_LANDINGPAGE',
  CLICK_NAV_STARTNOW_LANDINGPAGE: 'CLICK_NAV_STARTNOW_LANDINGPAGE',
  CLICK_HERO_TRYOUT_LANDINGPAGE: 'CLICK_HERO_TRYOUT_LANDINGPAGE',
  CLICK_HERO_YOUTUBE_LANDINGPAGE: 'CLICK_HERO_YOUTUBE_LANDINGPAGE',
  CLICK_FEATURES_TRYSELF_LANDINGPAGE: 'CLICK_FEATURES_TRYSELF_LANDINGPAGE',
  CLICK_SIDEBAR_COLLAPSE: 'CLICK_SIDEBAR_COLLAPSE',
  CLICK_PLAY_VIDEO_HELP_SUPPORT: 'CLICK_PLAY_VIDEO_HELP_SUPPORT',
  CLICK_SUPPORT_HELP_SUPPORT: 'CLICK_SUPPORT_HELP_SUPPORT',
  CLICK_SUPPORT_EMAIL_WITH_LOGS: 'CLICK_SUPPORT_EMAIL_WITH_LOGS',
  COMPARE_PLAN_DETAILS_LANDINGPAGE: 'COMPARE_PLAN_DETAILS_LANDINGPAGE',
  CLICK_COMPARE_RADARCHART_TALENT: 'CLICK_COMPARE_RADARCHART_TALENT',
  CLICK_VIEW_RADARCHART_TALENT: 'CLICK_VIEW_RADARCHART_TALENT',
  OPEN_CSV_EXPORT: 'OPEN_CSV_EXPORT',
  ABORT_CSV_EXPORT: 'ABORT_CSV_EXPORT',
  COMPLETE_CSV_EXPORT: 'COMPLETE_CSV_EXPORT',
  SEND_TEST_EMAIL: 'SEND_TEST_EMAIL',
  CLICK_CHANGE_LANGUAGE_LANDINGPAGE: 'CLICK_CHANGE_LANGUAGE_LANDINGPAGE',
  SHOW_HELP_SUPPORT_HINT: 'SHOW_HELP_SUPPORT_HINT',
  SHOW_FAVORED_SPACE_HINT: 'SHOW_FAVORED_SPACE_HINT',
  CLICK_DIMENSION_TOOLTIP: 'CLICK_DIMENSION_TOOLTIP',
  CLICK_FUNNEL_DISCOVER_STRENGTH_WEBAPP:
    'CLICK_FUNNEL_DISCOVER_STRENGTH_WEBAPP',
  CANCEL_INVITE_USER: 'CANCEL_INVITE_USER',
  INVITE_USER: 'INVITE_USER',
  EDIT_SPACE_PERSON: 'EDIT_SPACE_PERSON',
  START_ONBOARDING: 'START_ONBOARDING',
  SET_ONBOARDING_FIRSTNAME: 'SET_ONBOARDING_FIRSTNAME',
  SET_ONBOARDING_LASTNAME: 'SET_ONBOARDING_LASTNAME',
  SET_ONBOARDING_COMPANY_NAME: 'SET_ONBOARDING_COMPANY_NAME',
  SET_ONBOARDING_COMPANY_DISPLAY_NAME: 'SET_ONBOARDING_COMPANY_DISPLAY_NAME',
  SET_ONBOARDING_PLANNED_HIRES: 'SET_ONBOARDING_PLANNED_HIRES',
  FINISH_ONBOARDING: 'FINISH_ONBOARDING',
  CLICK_MORE_INFO_DIMENSION: 'CLICK_MORE_INFO_DIMENSION',
  REFETCH_NOW: 'REFETCH_NOW',
  CLICK_SETTINGS_RESET_CACHE: 'CLICK_SETTINGS_RESET_CACHE',
  CLICK_CHANGE_LOCATION: 'CLICK_CHANGE_LOCATION',
  CLICK_CHANGE_LOCATION_ACCESS_DENIED: 'CLICK_CHANGE_LOCATION_ACCESS_DENIED',
  CLICK_CHANGE_LOCATION_ACCESS_EXPIRED: 'CLICK_CHANGE_LOCATION_ACCESS_EXPIRED',
  SET_ACTIVE_SPACE_AUTOMATICALLY: 'SET_ACTIVE_SPACE_AUTOMATICALLY',
  SPACE_AUTO_SWITCH_ACCESS_EXPIRED: 'SPACE_AUTO_SWITCH_ACCESS_EXPIRED',
  CLICK_HINT_GO_TO_AUTOMATIONS: 'CLICK_HINT_GO_TO_AUTOMATIONS',
  CAREERS_MATCHING_SHOW_DIAGNOSTIC_VERSION_1:
    'CAREERS_MATCHING_SHOW_DIAGNOSTIC_VERSION_1',
  CAREERS_MATCHING_SHOW_DIAGNOSTIC_VERSION_2:
    'CAREERS_MATCHING_SHOW_DIAGNOSTIC_VERSION_2',
  DISCOVER_INTRO_ASSESSMENT_HIDE_INTRO: 'DISCOVER_INTRO_ASSESSMENT_HIDE_INTRO',
  DISCOVER_INTRO_ASSESSMENT_RESET_INTRO:
    'DISCOVER_INTRO_ASSESSMENT_RESET_INTRO',
  DISCOVER_CLICK_CHECK_FIT_WITH_POSITION:
    'DISCOVER_CLICK_CHECK_FIT_WITH_POSITION',
  DISCOVER_CLICK_ANALYZE_TALENT: 'DISCOVER_CLICK_ANALYZE_TALENT',
  DISCOVER_CLICK_SKIP_WELCOME_VIDEO: 'DISCOVER_CLICK_SKIP_WELCOME_VIDEO',
  DISCOVER_CLICK_PLAY_WELCOME_VIDEO: 'DISCOVER_CLICK_PLAY_WELCOME_VIDEO',
  DISCOVER_INTRO_CLICK_START_ASSESSMENT:
    'DISCOVER_INTRO_CLICK_START_ASSESSMENT',
  DISCOVER_INTRO_CLICK_START_ASSESSMENT_CTA:
    'DISCOVER_INTRO_CLICK_START_ASSESSMENT_CTA',
  DISCOVER_PRESSED_CREATE_CAREER: 'DISCOVER_PRESSED_CREATE_CAREER',
  DISCOVER_PRESSED_INVITE_TALENT: 'DISCOVER_PRESSED_INVITE_TALENT',
  DISCOVER_PRESSED_CREATE_CAREER_OPTION_1:
    'DISCOVER_PRESSED_CREATE_CAREER_OPTION_1',
  DISCOVER_PRESSED_CREATE_CAREER_OPTION_2:
    'DISCOVER_PRESSED_CREATE_CAREER_OPTION_2',
  DISCOVER_PRESSED_CLOSE_CAREER: 'DISCOVER_PRESSED_CLOSE_CAREER',
  DISCOVER_PRESSED_CLOSE_TALENT: 'DISCOVER_PRESSED_CLOSE_TALENT',
  DISCOVER_PRESSED_DIMENSION_MATCH_BREAKDOWN:
    'DISCOVER_PRESSED_DIMENSION_MATCH_BREAKDOWN',
  DISCOVER_PRESSED_NEXT_STEPS_PROMPT_PRIMARY_ACTION:
    'DISCOVER_PRESSED_NEXT_STEPS_PROMPT_PRIMARY_ACTION',
  DISCOVER_PRESSED_NEXT_STEPS_PROMPT_SECONDARY_ACTION:
    'DISCOVER_PRESSED_NEXT_STEPS_PROMPT_SECONDARY_ACTION',
  DISCOVER_PRESSED_DOWNLOAD_MATCHING_PROFILE:
    'DISCOVER_PRESSED_DOWNLOAD_MATCHING_PROFILE',
  DISCOVER_PRESSED_TALENT_MATCH_SUGGESTIONS_TALENT:
    'DISCOVER_PRESSED_TALENT_MATCH_SUGGESTIONS_TALENT',
  DISCOVER_START_JOYRIDE_ONBOARDING_TOUR:
    'DISCOVER_START_JOYRIDE_ONBOARDING_TOUR',
  DISCOVER_END_JOYRIDE_ONBOARDING_TOUR: 'DISCOVER_END_JOYRIDE_ONBOARDING_TOUR',
  DISCOVER_PRESSED_BETTER_MATCH_SUGGESTIONS:
    'DISCOVER_PRESSED_BETTER_MATCH_SUGGESTIONS',
  DISCOVER_PRESSED_CAREER_RELATED_CAREERS:
    'DISCOVER_PRESSED_CAREER_RELATED_CAREERS',
  DISCOVER_CLICK_ASSISTANT_CHANCE_AND_RISK:
    'DISCOVER_CLICK_ASSISTANT_CHANCE_AND_RISK',
  DISCOVER_CLICK_ASSISTANT_RECOMMENDATIONS:
    'DISCOVER_CLICK_ASSISTANT_RECOMMENDATIONS',
  DISCOVER_CLICK_PROFILE_OPTION: 'DISCOVER_CLICK_PROFILE_OPTION',
  DISCOVER_CLICK_SKILLS_INSIGHTS: 'DISCOVER_CLICK_SKILLS_INSIGHTS',
  DISCOVER_CLICK_CULTURE_INSIGHTS: 'DISCOVER_CLICK_CULTURE_INSIGHTS',
  DISCOVER_CLICK_PERSONALITY_INSIGHTS: 'DISCOVER_CLICK_PERSONALITY_INSIGHTS',
  DISCOVER_CLICK_PROFESSIONAL_INTERESTS_INSIGHTS:
    'DISCOVER_CLICK_PROFESSIONAL_INTERESTS_INSIGHTS',
  DISCOVER_CLICK_TALENT_PROFILE_DIMENSION_TITLE:
    'DISCOVER_CLICK_TALENT_PROFILE_DIMENSION_TITLE',
  DISCOVER_CLICK_REQUIREMENT_PROFILE_DIMENSION_TITLE:
    'DISCOVER_CLICK_REQUIREMENT_PROFILE_DIMENSION_TITLE',
  DISCOVER_CLICK_TEAM_PROFILE_DIMENSION_TITLE:
    'DISCOVER_CLICK_TEAM_PROFILE_DIMENSION_TITLE',
  DISCOVER_TOGGLE_TEAM_PROFILE_REQUIREMENT:
    'DISCOVER_TOGGLE_TEAM_PROFILE_REQUIREMENT',
  // CREATE CAREER FUNNEL
  // Step view events — use these to build a funnel diagram
  CREATE_CAREER_STEP_1_VIEWED: 'CREATE_CAREER_STEP_1_VIEWED', // Informationen
  CREATE_CAREER_STEP_2_VIEWED: 'CREATE_CAREER_STEP_2_VIEWED', // Kulturprofil
  CREATE_CAREER_STEP_3_VIEWED: 'CREATE_CAREER_STEP_3_VIEWED', // Anforderungsprofil
  CREATE_CAREER_STEP_4_VIEWED: 'CREATE_CAREER_STEP_4_VIEWED', // Testbatterie / Anpassung
  CREATE_CAREER_STEP_5_VIEWED: 'CREATE_CAREER_STEP_5_VIEWED', // Übersicht
  // Step 2 — Cultural fit: which profile type was used
  CREATE_CAREER_CULTURAL_FIT_PARTNER_PROFILE_USED:
    'CREATE_CAREER_CULTURAL_FIT_PARTNER_PROFILE_USED',
  CREATE_CAREER_CULTURAL_FIT_CUSTOM_PROFILE_USED:
    'CREATE_CAREER_CULTURAL_FIT_CUSTOM_PROFILE_USED',
  CREATE_CAREER_CULTURAL_FIT_MODE_SELECTED:
    'CREATE_CAREER_CULTURAL_FIT_MODE_SELECTED',
  CREATE_CAREER_CULTURAL_FIT_DREAMTEAM_PARTNER_PROFILE_USED:
    'CREATE_CAREER_CULTURAL_FIT_DREAMTEAM_PARTNER_PROFILE_USED',
  CREATE_CAREER_CULTURAL_FIT_DREAMTEAM_CUSTOM_PROFILE_USED:
    'CREATE_CAREER_CULTURAL_FIT_DREAMTEAM_CUSTOM_PROFILE_USED',
  CREATE_CAREER_CULTURAL_FIT_CUSTOMIZE_STARTED:
    'CREATE_CAREER_CULTURAL_FIT_CUSTOMIZE_STARTED',
  CREATE_CAREER_CULTURAL_FIT_RESET_TO_COMPANY:
    'CREATE_CAREER_CULTURAL_FIT_RESET_TO_COMPANY',
  // Step 4 — Testbattery: optional challenge interactions
  CREATE_CAREER_TESTBATTERY_OPTIONAL_CHALLENGE_ADDED:
    'CREATE_CAREER_TESTBATTERY_OPTIONAL_CHALLENGE_ADDED',
  CREATE_CAREER_TESTBATTERY_OPTIONAL_CHALLENGE_REMOVED:
    'CREATE_CAREER_TESTBATTERY_OPTIONAL_CHALLENGE_REMOVED',
  CREATE_CAREER_TESTBATTERY_EXPERT_MODE_STARTED:
    'CREATE_CAREER_TESTBATTERY_EXPERT_MODE_STARTED',
  // Step 4 (expert mode) — Adjustment: tab navigation
  CREATE_CAREER_ADJUSTMENT_TAB_CHANGED: 'CREATE_CAREER_ADJUSTMENT_TAB_CHANGED',
  // Der Expertenmodus speichert seit dem Instant-Apply-Umbau kontinuierlich.
  // career_must_criteria_saved ist damit entfallen, sein count_before hing an
  // einem expliziten Klick und hat unter Debounce keine Bedeutung mehr. Die
  // Aussage "hat der Kunde etwas veraendert" tragen jetzt die beiden
  // Abschluss-Events, sie rechnen gegen den Stand beim Betreten.
  CREATE_CAREER_ADJUSTMENT_CHALLENGE_TOGGLED:
    'CREATE_CAREER_ADJUSTMENT_CHALLENGE_TOGGLED',
  CREATE_CAREER_ADJUSTMENT_DIFFICULTY_CHANGED:
    'CREATE_CAREER_ADJUSTMENT_DIFFICULTY_CHANGED',
  CREATE_CAREER_ADJUSTMENT_MUST_CRITERION_TOGGLED:
    'CREATE_CAREER_ADJUSTMENT_MUST_CRITERION_TOGGLED',
  CREATE_CAREER_ADJUSTMENT_COMPLETED: 'CREATE_CAREER_ADJUSTMENT_COMPLETED',
  CREATE_CAREER_ADJUSTMENT_ABORTED: 'CREATE_CAREER_ADJUSTMENT_ABORTED',
  ONBOARDING_CREATE_JOB_CLICKED: 'ONBOARDING_CREATE_JOB_CLICKED',
  ONBOARDING_INVITE_CANDIDATE_CLICKED: 'ONBOARDING_INVITE_CANDIDATE_CLICKED',
  ONBOARDING_CONTINUE_LATER_CLICKED: 'ONBOARDING_CONTINUE_LATER_CLICKED',
  ONBOARDING_CONTINUE_MODAL_SHOWN: 'ONBOARDING_CONTINUE_MODAL_SHOWN',

  // Experimente (src/features/experiments)
  EXPERIMENT_EXPOSED: 'EXPERIMENT_EXPOSED',

  // Q4-Funnel Drop-off-Tracking (public route /funnel)
  FUNNEL_Q4_INTRO_VIEWED: 'FUNNEL_Q4_INTRO_VIEWED',
  FUNNEL_Q4_STEP_VIEWED: 'FUNNEL_Q4_STEP_VIEWED',
  FUNNEL_Q4_BACK_CLICKED: 'FUNNEL_Q4_BACK_CLICKED',
  FUNNEL_Q4_EMAIL_SUBMITTED: 'FUNNEL_Q4_EMAIL_SUBMITTED',
  FUNNEL_Q4_EMAIL_BLOCKED: 'FUNNEL_Q4_EMAIL_BLOCKED',
  // Talent-Weiche unter dem E-Mail-Feld. Wert bleibt der lowercase-String,
  // mit dem das Event vor der Konstanten-Einführung gefeuert wurde — sonst
  // brechen historische Auswertungen.
  FUNNEL_TALENT_HINT_SHOWN: 'funnel_talent_hint_shown',
  FUNNEL_Q4_RESULT_VIEWED: 'FUNNEL_Q4_RESULT_VIEWED',
  // Done-Screen: wann wurde der Dashboard-CTA freigegeben? source='ready_signal'
  // (Backend hat partner_id geschrieben) vs. 'countdown_fallback' (Signal kam
  // nicht, Countdown hat freigegeben). waited_ms macht die echte Dauer der
  // Account-Anlage messbar — bisher war die "~15s" nur eine Annahme.
  FUNNEL_Q4_ACCOUNT_READY: 'FUNNEL_Q4_ACCOUNT_READY',
  FUNNEL_Q4_CTA_CLICKED: 'FUNNEL_Q4_CTA_CLICKED',
  FUNNEL_Q4_ENDSCREEN_VIEWED: 'FUNNEL_Q4_ENDSCREEN_VIEWED',
  FUNNEL_Q4_BRANDFETCH_SUCCESS: 'FUNNEL_Q4_BRANDFETCH_SUCCESS',
  FUNNEL_Q4_BRANDFETCH_SKIPPED: 'FUNNEL_Q4_BRANDFETCH_SKIPPED',
  FUNNEL_Q4_BRANDFETCH_NOT_OK: 'FUNNEL_Q4_BRANDFETCH_NOT_OK',
  FUNNEL_Q4_BRANDFETCH_NO_EMPLOYEES: 'FUNNEL_Q4_BRANDFETCH_NO_EMPLOYEES',
  FUNNEL_Q4_BRANDFETCH_ERROR: 'FUNNEL_Q4_BRANDFETCH_ERROR',
  // Spalten-Einstellungen pro User in den Tabellen /talents und /careers
  OPEN_TABLE_COLUMN_SETTINGS: 'OPEN_TABLE_COLUMN_SETTINGS',
  TOGGLE_TABLE_COLUMN: 'TOGGLE_TABLE_COLUMN',
  REORDER_TABLE_COLUMNS: 'REORDER_TABLE_COLUMNS',
  RESET_TABLE_COLUMNS: 'RESET_TABLE_COLUMNS',
  SHOW_ALL_TABLE_COLUMNS: 'SHOW_ALL_TABLE_COLUMNS',
  OPEN_TABLE_COLUMN_DEFAULTS: 'OPEN_TABLE_COLUMN_DEFAULTS',
  UPDATE_DASHBOARD_TABLE_COLUMNS_SETTINGS:
    'UPDATE_DASHBOARD_TABLE_COLUMNS_SETTINGS',
  // Eigene Talent-Status (Admin-Einstellung unter /settings/talent-status)
  OPEN_TALENT_STATUS_SETTINGS: 'OPEN_TALENT_STATUS_SETTINGS',
  CREATE_TALENT_STATUS: 'CREATE_TALENT_STATUS',
  UPDATE_TALENT_STATUS: 'UPDATE_TALENT_STATUS',
  ARCHIVE_TALENT_STATUS: 'ARCHIVE_TALENT_STATUS',
  RESTORE_TALENT_STATUS: 'RESTORE_TALENT_STATUS',
  // Pakete und Limits (src/features/pricing), jeweils mit source, plan und
  // mode. PRESSED_PAYWALL bleibt für legacy und preview bestehen.
  PRICING_LOCK_PRESSED: 'PRICING_LOCK_PRESSED',
  PRICING_DIALOG_VIEWED: 'PRICING_DIALOG_VIEWED',
  PRICING_REQUEST_SENT: 'PRICING_REQUEST_SENT',
  PRICING_MEETING_PRESSED: 'PRICING_MEETING_PRESSED',
  PRICING_LIMIT_BLOCKED: 'PRICING_LIMIT_BLOCKED'
}
